import React, { useState, useImperativeHandle, forwardRef } from "react";
import PageLFD from "./pages/PageLFD";
import PagePFD from "./pages/PagePFD";
// import "./progApp.css";

const LobbySection = forwardRef(
  (
    {
      inputValues,
      currentBuildNavNumber,
      onValidationResult,
      onLfdFileChange,
      onPfdFileChange,
      onWarningMessage,
      setMediaExtensions,
      setMediaExtensionPortrait
    },
    ref
  ) => {
    // Lobby-specific state and handlers
    const [lfdFile, setLfdFile] = useState({});
    const [pfdFile, setPfdFile] = useState({});
    const [svgFile, setSvgFile] = useState({});
    const [standardAdFile, setStandardAdFile] = useState({});
    // const [mediaExtensions, setMediaExtensions] = useState({}); //* this is now a prop, we never used mediaExtensions here anyway so we only needed the setter
    const [continueButtonDisabled, setContinueButtonDisabled] = useState(false);
    console.log(`what is continueButtonDisabled(${continueButtonDisabled}`); //* continueButtonDisabled seems to be unused? remove it?

    const handleDropzoneChanges = (name, value, droppedFileType) => {
      if (droppedFileType === "svg") {
        setSvgFile(prevState => ({ ...prevState, [name]: value }));
      } else if (droppedFileType === "standardAd") {
        setStandardAdFile(prevState => ({ ...prevState, [name]: value }));
      } else if (droppedFileType === "landscape") {
        setLfdFile(prevState => ({ ...prevState, [name]: value }));
      } else if (droppedFileType === "portrait") {
        setPfdFile(prevState => ({ ...prevState, [name]: value }));
      }

      // Duplicate LFD asset to PFD if PFD is empty //* LFD asset -> PFD update
      if (name === "lfdFile" && !pfdFile.payload) {
        console.log("LobbySection.js setPfdFile with LFD file.");
        setPfdFile(value);
      } else {
        console.log(
          "LobbySection.js setPfdFile with LFD file did not happen, was it suppose to?."
        );
      }

      //* each file drop will add or update the corresponding key (.landscape and .portrait)
      if (name === "name") {
        const splitValue = value.split(".");
        setMediaExtensions(prevState => ({
          ...prevState,
          [droppedFileType]: splitValue[splitValue.length - 1]
        }));
      }
    };

    // Notify parent when lfdFile or pfdFile changes
    React.useEffect(() => {
      if (onLfdFileChange) onLfdFileChange(lfdFile);
    }, [lfdFile]);
    React.useEffect(() => {
      if (onPfdFileChange) onPfdFileChange(pfdFile);
    }, [pfdFile]);

    const handleWarningMessageText = (txt, showIcon) => {
      if (onWarningMessage) {
        onWarningMessage(txt, showIcon);
      }
    };

    const handleContinueButtonDisabled = bool => {
      setContinueButtonDisabled(bool);
    };

    // Example validation logic (customize as needed)
    const validate = () => {
      let errors = [];
      // Accept any File/Blob in lfdFile as valid
      const hasLfdFile =
        lfdFile &&
        Object.values(lfdFile).some(
          v => v instanceof File || v instanceof Blob
        );
      const hasPfdFile =
        pfdFile &&
        Object.values(pfdFile).some(
          v => v instanceof File || v instanceof Blob
        );
      if (!hasLfdFile)
        errors.push("LFD file missing or has incorrect dimensions");
      if (!hasPfdFile)
        errors.push("PFD file missing or has incorrect dimensions");
      // Add more validation as needed
      handleWarningMessageText(errors.join(", "), errors.length > 0);
      return errors.length === 0;
    };

    // Real file creation logic
    const createFiles = () => {
      // Example: Generate HTML, manifest, and asset files
      // Use inputValues and dropped files (lfdFile, pfdFile, svgFile, standardAdFile)
      const results = {};
      // HTML file
      if (lfdFile.payload) {
        results.lfdHtml = `<html><body><img src='${lfdFile.payload.name}' /></body></html>`;
      }
      if (pfdFile.payload) {
        results.pfdHtml = `<html><body><img src='${pfdFile.payload.name}' /></body></html>`;
      }
      // Manifest file
      results.manifest = {
        creativeID: inputValues.creativeID,
        lfdAsset: lfdFile.payload ? lfdFile.payload.name : null,
        pfdAsset: pfdFile.payload ? pfdFile.payload.name : null,
        svgAsset: svgFile.payload ? svgFile.payload.name : null,
        standardAdAsset: standardAdFile.payload
          ? standardAdFile.payload.name
          : null
      };
      // Asset files
      results.assets = [];
      if (lfdFile.payload) results.assets.push(lfdFile.payload);
      if (pfdFile.payload) results.assets.push(pfdFile.payload);
      if (svgFile.payload) results.assets.push(svgFile.payload);
      if (standardAdFile.payload) results.assets.push(standardAdFile.payload);
      // Return results for parent to use
      return results;
    };

    // Expose validate and createFiles to parent via ref
    useImperativeHandle(ref, () => ({
      validate,
      createFiles
    }));

    return (
      <div
        className="adBuildingPageContent lfdANDpfdContainer"
        id="screenGrabLobby"
      >
        <div
          className={`adBuildingPageInner lfd ${
            currentBuildNavNumber === 2 ? "hide" : ""
          }`}
        >
          <PageLFD
            handleDropzoneChanges={handleDropzoneChanges}
            handleWarningMessageText={handleWarningMessageText}
            handleContinueButtonDisabled={handleContinueButtonDisabled}
          />
        </div>
        <div
          className={`adBuildingPageInner pfd ${
            currentBuildNavNumber === 2 ? "hide" : ""
          }`}
        >
          <PagePFD
            handleDropzoneChanges={handleDropzoneChanges}
            handleWarningMessageText={handleWarningMessageText}
            handleContinueButtonDisabled={handleContinueButtonDisabled}
          />
        </div>
        {/* Add more lobby-specific UI or logic here */}
      </div>
    );
  }
);

export default LobbySection;
